import React from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { signInWithEmailAndPassword } from 'firebase/auth'
import { auth } from '../firebase'

const Login = () => {
  const [loginError, setLoginError] = React.useState('')
  const navigate = useNavigate()

  const handleLogin = async (e) => {
    e.preventDefault()

    const { email: { value: email }, password: { value: password } } = e.target.elements

    try {
      await signInWithEmailAndPassword(auth, email, password)
      navigate('/', { replace: true })
    } catch ({ message }) {
      setLoginError(message)
    }
  }

  return (
    <div className='flex items-center justify-center h-full md:p-12'>
      <div className='grid lg:grid-cols-signup md:grid-cols-1 bg-white max-w-screen-lg mx-auto md:shadow-xl min-h-lg'>
        <div className='flex flex-col gap-16 px-16 py-16 md:px-28 md:py-24'>
          <form className='flex flex-col gap-12' onSubmit={handleLogin}>
            <span className='!leading-snug text-justify text-title md:text-5xl mb-4 tracking-tighter'>Login and continue your chat with friends and family</span>
            <input type='email' name='email' placeholder='Email' />
            <input type='password' name='password' placeholder='Password' className='mb-6' />
            <button className='self-start px-8 py-4 md:px-10 md:py-5 text-3xl tracking-tighter bg-purple-light text-white rounded-2xl'>Login</button>
            {loginError && <span>{loginError}</span>}
          </form>

          <span>Don't have an account? <Link to='/register' className='text-purple-dark font-semibold underline'>register</Link></span>
        </div>

        <div className='relative bg-purple-light p-16 overflow-hidden hidden lg:inline-block'>
          <span className='text-gray-100 text-9xl font-bold tracking-tighter'>Welcome to Tchat family</span>
          <span className='absolute left-4 bottom-1 text-10xl text-dark-20 font-extrabold'>Tchat.</span>
        </div>
      </div>
    </div>
  )
}

export default Login